module.exports = __webpack_public_path__ + "img/MF.1e9bb81d.svg";